import { useEffect, useState } from "react";
import { useTranslation } from "../context/TranslationContext";
import Button from "./ds/Button";
import Modal from "./ds/Modal";
import TextField from "./ds/TextField";

const PromptModal = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  message,
  placeholder,
  submitLabel,
  cancelLabel,
  isDark = true,
  initialValue = "",
  maxLength = 120,
  loading = false,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (isOpen) setValue(initialValue);
  }, [isOpen, initialValue]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
  };

  return (
    <Modal open={isOpen} onClose={onClose} title={title} description={message} closeLabel={t("common.close")} isDark={isDark} width="min-[600px]:w-[420px]">
      <form onSubmit={handleSubmit} className="flex flex-col gap-space-20">
        <TextField
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          maxLength={maxLength}
        />
        <div className="flex justify-end gap-space-12">
          <Button variant="gray" disabled={loading} onClick={onClose}>
            {cancelLabel || t("common.cancel")}
          </Button>
          <Button type="submit" disabled={!value.trim()} loading={loading}>
            {submitLabel || t("common.save")}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default PromptModal;
